import { isDefined } from 'notable-common';
import { z } from 'zod';
import { FlowRunState } from './flowRunState.js';
import { FlowRunType } from './runType.js';
import { FlowDefinitionState } from '../flowDefinition/flowDefinition.js';
/**
 * The filters a selective `flow_runs` index backs. A stats request must carry at least one, or it
 * scans the table (NC-4518).
 */
export const SELECTIVE_FLOW_RUN_STATS_FILTERS = [
    'flowId',
    'flowDefinitionId',
    'agentId',
    'entityId',
    'groupId',
];
/** Query parameters `GET /flow-runs/stats` accepts. */
export const FlowRunStatsQuerySchema = z
    .object({
    organizationId: z.uuid().optional(),
    agentId: z.uuid().optional(),
    flowDefinitionId: z.uuid().optional(),
    flowId: z.uuid().optional(),
    createdBefore: z.coerce.date().optional(),
    createdAfter: z.coerce.date().optional(),
    state: z.union([z.array(z.enum(FlowRunState)), z.enum(FlowRunState)]).optional(),
    flowDefinitionState: z
        .union([z.array(z.enum(FlowDefinitionState)), z.enum(FlowDefinitionState)])
        .optional(),
    flowRunType: z.union([z.array(z.enum(FlowRunType)), z.enum(FlowRunType)]).optional(),
    version: z.union([z.array(z.string()), z.string()]).optional(),
    // Non-empty: an empty groupId is dropped by the query builder, so it must not satisfy the
    // selective-filter check below.
    groupId: z.string().min(1).optional(),
    entityId: z.uuid().optional(),
    startedByEmail: z.string().optional(),
})
    .superRefine((query, context) => {
    if (!SELECTIVE_FLOW_RUN_STATS_FILTERS.some((key) => isDefined(query[key]))) {
        context.addIssue({
            code: 'custom',
            message: 'flow-runs/stats requires at least one selective filter: flowId, flowDefinitionId, agentId, entityId, or groupId.',
        });
    }
});
//# sourceMappingURL=stats.js.map